var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardListUpIcon = function SvgNewcsDashboardListUpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 12
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_list_up_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M162 434h10v12h-10z",
    "data-name": "\\u77E9\\u5F62 463"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#f44336",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    clipPath: "url(#newcs_dashboard_list_up_icon_svg__a)",
    transform: "translate(-162 -434)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m162.776 438.958 4.229-4.221 4.229 4.221",
    "data-name": "\\u8DEF\\u5F84 379"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.998 435.223v10",
    "data-name": "\\u8DEF\\u5F84 380"
  }))));
};
export default SvgNewcsDashboardListUpIcon;